/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');
const Config = require('../../configs/Config.js');

const AnswerStore = require('../../stores/AnswerStore.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');

const PriceSection = require('./PriceSection.jsx');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

import { VelocityComponent } from 'velocity-react';

const ReviewSection = React.createClass({
  propTypes: {
    answers: React.PropTypes.object
  },

  getInitialState() {
    return {
      isActive: false
    };
  },

  toggleActive() {
    this.setState({
      isActive: !this.state.isActive
    });
  },

  getPriceSavings(answer, itemCode) {
    let price = _.get(answer.part, 'pricing');
    if (!_.get(answer.part, 'pricing')) {
      return '';
    }

    var country = !_.isNull(ProductStore.getSchoolCountry()) && !_.isEmpty(ProductStore.getSchoolCountry()) 
      && ProductStore.getSchoolCountry() || 'default';
    const currency = _.get(Config, 'currency.' + country) || '$';

    if (price && _.keys(price).length > 1 && itemCode && price[itemCode] && parseFloat(price[itemCode].retail_price) < parseFloat(price[itemCode].full_price)) {
      return (' - Save ' + currency) + parseFloat(price[itemCode].full_price - price[itemCode].retail_price).toFixed(2);
    } else if (price && _.keys(price).length === 1 && parseFloat(_.values(price)[0].retail_price) < parseFloat(_.values(price)[0].full_price)) {
      return (' - Save ' + currency) + parseFloat(_.values(price)[0].full_price - _.values(price)[0].retail_price).toFixed(2);
    }
  },

  getPromoDisplay() {
    if (__VENDOR__ === 'netsuite') {
      let promoCodes = Loader.promoCode != null ? Loader.promoCode : AnswerStore.getPromoCode();
      if (!!promoCodes) {
        return (
          <div className="uc-review-answer">
            <strong>Promo Code(s):</strong> {promoCodes}
          </div>
        );
      }
    }

    return null;
  },

  render() {
    let activeClass = this.state.isActive ? ' uc-active' : '';
    let itemCode = AnswerStore.itemCode;

    let animation = this.state.isActive ? 'slideDown' : 'slideUp';
    if (window.innerWidth >= Config.breakpoints.small) animation = 'slideDown';

    return (
      <div className="uc-review-section">
        <div className={'uc-review-button' + activeClass} onClick={this.toggleActive}>Selection Summary</div>

        <VelocityComponent component="div"
          animation={animation}
          duration={300}
          style={this.state.isActive ? { height: '' } : null}>
          <div className="uc-review-answers">
            {_.chain(this.props.answers)
              .filter(answer => {
                return !_.get(answer.question, 'metadata.HideFromReviewSection');
              })
              .sortBy(answer => {
                return parseInt(answer.question.sort)
              })
              .map(answer => {
                let questionDisplayName = _.get(answer.question, `metadata.lang.${ln}.DisplayName`) || answer.question.name;
                let answerDisplay = answer.input || _.get(answer.part, `metadata.lang.${ln}.DisplayName`) || answer.part.name;
                let priceSavingsDisplay = this.getPriceSavings(answer, itemCode);

                if (__VENDOR__ === 'netsuite' && _.get(answer.part, 'metadata.MMV')) {
                  answerDisplay += ' (' + _.get(answer.part, 'metadata.MMV') + ')';
                }

                return (
                  <div className="uc-review-answer" key={answer.question.id}>
                    <strong>{questionDisplayName}:</strong> {answerDisplay}
                    <span className='uc-review-answer-price'>{priceSavingsDisplay}</span>
                  </div>
                );
              })
              .value()}
            {this.getPromoDisplay()}
          </div>
        </VelocityComponent>
      </div>
    );
  }
});

module.exports = ReviewSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/ReviewSection.jsx